import React from 'react';
import { SEO } from '../components/SEO';
import { buildBreadcrumbList, buildServiceSchema } from '../lib/structuredData';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, ShieldIcon, ZapIcon, DatabaseIcon, ActivityIcon, CheckCircleIcon, ServerIcon, LockIcon, TrendingUpIcon, RefreshCwIcon, MailIcon, ShoppingCartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const HostingPage: React.FC = () => {
  const hostingFeatures = [{
    icon: <RefreshCwIcon className="h-6 w-6" data-id="element-1528" data-mp="3tuyxbgcaxepk" />,
    title: 'Managed hosting en updates',
    description: "Wij draaien de updates van WordPress, thema's en plugins op een rustig moment. Jij hoeft niet bang te zijn dat je site er kapot van gaat."
  }, {
    icon: <LockIcon className="h-6 w-6" data-id="element-1529" data-mp="23jcb2xttuv8b" />,
    title: 'SSL en beveiliging',
    description: 'SSL-certificaat ingeregeld en automatisch verlengd. Actieve beveiliging, malware-detectie en bescherming tegen ongewenste toegang.'
  }, {
    icon: <ZapIcon className="h-6 w-6" data-id="element-1530" data-mp="31y778q4e6ohi" />,
    title: 'Snelheid en performance',
    description: 'Caching, image-optimalisatie en een server-stack die je bezoekers niet laat wachten, ook niet op piekmomenten.'
  }, {
    icon: <DatabaseIcon className="h-6 w-6" data-id="element-1531" data-mp="3awsomhy4nxgp" />,
    title: 'Backups en monitoring',
    description: 'Dagelijkse backups en 24/7 monitoring, zodat problemen vaak al opgelost zijn voordat jij ze opmerkt.'
  }];
  const inclusions = ['Managed WordPress hosting op onze eigen omgeving', 'SSL-certificaat, automatisch verlengd', 'Dagelijkse backups, 14 dagen bewaard', "Wekelijkse updates van WordPress, thema's en plugins", '24/7 monitoring met directe melding bij downtime', 'Anti-spam, antivirus en bot-bescherming', 'Razendsnelle laadtijden met caching en optimalisatie', 'Persoonlijk contact met het team dat je site bouwde'];
  const benefits = [{
    icon: <CheckCircleIcon className="h-6 w-6" data-id="element-1532" data-mp="31bg1z572b1sf" />,
    title: 'Hosting voor financieel adviseurs',
    description: 'Speciaal afgestemd op zakelijke dienstverleners die op een veilige en stabiele site moeten kunnen vertrouwen.'
  }, {
    icon: <ServerIcon className="h-6 w-6" data-id="element-1533" data-mp="3f19rzquazs3q" />,
    title: 'Webhosting voor administratiekantoren',
    description: 'Betrouwbaar, met garantie op uptime en snelheid, op een omgeving die wij zelf onderhouden.'
  }, {
    icon: <ActivityIcon className="h-6 w-6" data-id="element-1534" data-mp="3oxcu4wp5nqqo" />,
    title: 'Hosting op maat voor MKB',
    description: 'Flexibele oplossing die meegroeit met je bedrijf, zonder dat je over moet stappen.'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6" data-id="element-1535" data-mp="1sdq3r5cmdhk" />,
    title: 'Betere afstemming met SEO',
    description: 'Technische SEO-optimalisaties voeren we direct door, zonder discussie met een externe partij.'
  }, {
    icon: <MailIcon className="h-6 w-6" data-id="element-1536" data-mp="1w227zpaz0zbc" />,
    title: 'Zakelijke e-mail naast je hosting',
    description: 'Combineer je hosting met onze e-mail pakketten (Starter, Premium of Google Workspace) voor één compleet pakket.'
  }];
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-1537" data-mp="1mcsdk2snn4k2">
      <SEO title="Zakelijke hosting voor €34,99 per maand | Noord Digital" description="Managed hosting voor zakelijke websites, vaste prijs van €34,99 per maand. Inclusief SSL, dagelijkse backups, 24/7 monitoring en wekelijkse updates. Geschikt voor financieel adviseurs, administratiekantoren en zakelijke dienstverleners." keywords="managed hosting, zakelijke hosting, hosting financieel adviseur, webhosting administratiekantoor, SSL certificaat, dagelijkse backups, WordPress hosting, hosting MKB" canonical="https://noorddigital.nl/hosting" jsonLd={[buildServiceSchema({
      name: 'Hosting',
      description: 'Beheerde hosting voor zakelijke websites met dagelijkse back-ups, updates, monitoring en een vast aanspreekpunt.',
      path: '/hosting',
      serviceType: 'Managed webhosting'
    }), buildBreadcrumbList([{
      name: 'Hosting',
      path: '/hosting'
    }])]} data-id="element-1538" data-mp="1hequhhv8b58l" />
      <Header data-id="element-1539" data-mp="2w9p3rt4hopps" />

      {/* Hero */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#1B2B44] py-16 md:py-20 relative overflow-hidden" data-id="element-1540" data-mp="2wagxszifufdy">
        <div className="absolute inset-0 opacity-20" data-id="element-1541" data-mp="3180fyai9bcb6">
          <div className="w-full h-full bg-[url('https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80')] bg-cover bg-center" data-id="element-1542" data-mp="2n9agio7yt0jn"></div>
        </div>

        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-1543" data-mp="1bt2npeic53l6">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center" data-id="element-1544" data-mp="1fuxjk3hhyork">
            <div className="lg:col-span-7" data-id="element-1545" data-mp="18bocwi0dl467">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} className="font-bold text-white leading-tight mb-6 text-4xl md:text-5xl lg:text-6xl" data-id="element-1546" data-mp="18an3ehz0cpql">
                Managed hosting voor zakelijke websites, €34,99 per maand
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.1
            }} className="text-white text-opacity-90 mb-8 text-lg leading-relaxed" data-id="element-1547" data-mp="pkdp49py57ij">
                Eén vaste prijs, geen verrassingen achteraf. Wij hosten je website op onze eigen omgeving, regelen SSL, backups, monitoring en updates, en zijn bereikbaar als er iets is. Geschikt voor financieel adviseurs, administratiekantoren en andere zakelijke dienstverleners.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} className="flex flex-wrap gap-4" data-id="element-1548" data-mp="rjzt8itqnv00">
                <motion.a href="#hosting-prijs" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1549" data-mp="10clb7wpjpxns">
                  Bekijk wat erbij zit
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1550" data-mp="hltuub7556zw" />
                </motion.a>
                <motion.a href="/websites" whileHover={{
                scale: 1.05
              }} whileTap={{
                scale: 0.95
              }} className="inline-flex items-center px-6 py-3 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1551" data-mp="mlojs97cvmib">
                  Website laten maken
                  <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1552" data-mp="3dirpipkyp7k5" />
                </motion.a>
              </motion.div>
            </div>

            {/* Prijs-card */}
            <div className="lg:col-span-5" data-id="element-1553" data-mp="33t853fhlp5n6">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="bg-white rounded-2xl p-8 shadow-2xl relative" data-id="element-1554" data-mp="33s6u1b0l4j5g">
                <div className="absolute -top-4 left-6 inline-flex items-center gap-2 bg-[#007AFF] text-white text-xs font-semibold uppercase tracking-wide px-3 py-1.5 rounded-full shadow-md" data-id="element-1555" data-mp="2psdx2xygt6p1">
                  <ShieldIcon className="h-3 w-3" data-id="element-1556" data-mp="o22ej9iyr7q0" />
                  Vaste prijs, alles inbegrepen
                </div>
                <div className="text-center mb-6" data-id="element-1557" data-mp="j40vgoljf8ej">
                  <p className="text-[#6B7280] text-sm uppercase tracking-wide mb-2" data-id="element-1558" data-mp="3o2re8yv0q677">
                    Vanaf
                  </p>
                  <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-1559" data-mp="3t0sxpkwcw7j7">
                    <span className="text-6xl md:text-7xl font-bold text-[#111827]" data-id="element-1560" data-mp="3fazat84evxc4">
                      €34,99
                    </span>
                  </div>
                  <p className="text-[#6B7280] text-sm" data-id="element-1561" data-mp="3j9okapmbwuqh">per maand, excl. BTW</p>
                </div>

                <div className="space-y-3 pt-6 border-t border-gray-200 mb-6" data-id="element-1562" data-mp="35emgc811lfgb">
                  <div className="flex items-center gap-3" data-id="element-1563" data-mp="3aco250pursvh">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1564" data-mp="2wcda3uct488q" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1565" data-mp="30cndr0d4mmkf">
                      SSL-certificaat en wekelijkse updates inbegrepen
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1566" data-mp="ylk165joexx8">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1567" data-mp="yl0trirnjrxg" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1568" data-mp="2j4e29eutnccy">
                      Dagelijkse backups en 24/7 monitoring
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1569" data-mp="2stxkqjemh47a">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1570" data-mp="2svijkl7yz9ay" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1571" data-mp="2o0urydho5ys5">
                      99,9 procent uptime garantie
                    </span>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-1572" data-mp="2xrpgjoie1agr">
                    <CheckCircleIcon className="h-5 w-5 text-[#007AFF] flex-shrink-0" data-id="element-1573" data-mp="3bs9x0e0tyu73" />
                    <span className="text-sm text-[#6B7280]" data-id="element-1574" data-mp="36tfg5hmfbfpm">
                      Persoonlijk contact, geen ticketsysteem
                    </span>
                  </div>
                </div>

                <a href="/contact" className="inline-flex items-center justify-center w-full bg-[#007AFF] text-white font-semibold py-3 px-6 rounded-lg shadow-md" data-id="element-1575" data-mp="1hgbx52oevanv">
                  Vraag hosting aan
                  <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-1576" data-mp="qm2jtoi0u575" />
                </a>
              </motion.div>
            </div>
          </div>
        </div>
      </div>

      {/* Wat zit er inbegrepen */}
      <div id="hosting-prijs" className="w-full bg-white py-20 md:py-24" data-id="element-1577" data-mp="hnh3m000v29j">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1578" data-mp="1ecy9og2x2qbr">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1579" data-mp="1ab36t75c84vv">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1580" data-mp="1abmnkkj94n8b">
              Wat zit er bij die €34,99 per maand?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1581" data-mp="1t9p92pclc21d">
              Geen onderdelen die later los gefactureerd worden. Alles wat een zakelijke website nodig heeft om veilig en snel te blijven, zit erin.
            </motion.p>
          </div>

          <div className="max-w-4xl mx-auto bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 md:p-12 mb-12" data-id="element-1582" data-mp="2em67c2hsmi4f">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1583" data-mp="2jhvcqmghut8n">
              {inclusions.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-1584" data-mp="2t9j28hthq07h" data-mpi={i}>
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF] mt-0.5 flex-shrink-0" data-id="element-1585" data-mp="2taat5fc579rf" />
                  <span className="text-[#6B7280] leading-relaxed" data-id="element-1586" data-mp="2y7suokntympe">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1587" data-mp="378r0n8htx4am">
            {hostingFeatures.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-8 transition-all duration-300 group" data-id="element-1588" data-mp="1782kf89dwgoh" data-mpi={index}>
                <div className="flex items-start gap-4" data-id="element-1589" data-mp="1qwuvp2cbdh3l">
                  <motion.div whileHover={{
                scale: 1.1,
                rotate: 5
              }} className="flex-shrink-0 w-12 h-12 bg-[#007AFF] rounded-full flex items-center justify-center text-white" data-id="element-1590" data-mp="1lv5hxexpipbt">
                    {feature.icon}
                  </motion.div>
                  <div className="flex-1" data-id="element-1591" data-mp="5ignc87ygfhs">
                    <h3 className="font-bold text-[#111827] text-xl mb-2" data-id="element-1592" data-mp="5jiahb28wsfv">
                      {feature.title}
                    </h3>
                    <p className="text-[#6B7280] leading-relaxed" data-id="element-1593" data-mp="2c5o2rmzjnmv3">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* Waarom hosting bij Noord Digital */}
      <div className="w-full bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] py-20 md:py-24" data-id="element-1594" data-mp="27e610wpp5i92">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1595" data-mp="1tf6lqfo2qfpk">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-1596" data-mp="1ye9fv52in1ir">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1597" data-mp="1ycgb5vbgqrde">
              Waarom hosting bij Noord Digital?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed" data-id="element-1598" data-mp="3iue4d0cycxls">
              Bij veel hostingpartijen ben je een nummer. Bij ons krijg je persoonlijke aandacht, proactief onderhoud en een team dat je website kent. Hosting, website en SEO onder één dak betekent snellere doorvoering en betere resultaten.
            </motion.p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1599" data-mp="2b6fe87df5xll">
            {[{
            stat: '99,9%',
            label: 'Uptime garantie',
            description: 'Je website is altijd bereikbaar voor je klanten. Mocht er toch iets misgaan, dan zijn wij er direct bij.'
          }, {
            stat: '< 1s',
            label: 'Gemiddelde laadtijd',
            description: 'Snelle websites ranken beter in Google en zorgen voor een betere gebruikerservaring.'
          }, {
            stat: '24/7',
            label: 'Monitoring en support',
            description: 'We houden je website dag en nacht in de gaten. Problemen worden vaak opgelost voordat je ze merkt.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="bg-white rounded-2xl p-8 shadow-lg text-center" data-id="element-1600" data-mp="gvpftp80hx2p" data-mpi={index}>
                <div className="text-4xl md:text-5xl font-bold text-[#007AFF] mb-2" data-id="element-1601" data-mp="3pb0osba8d7wj">
                  {item.stat}
                </div>
                <div className="text-lg font-bold text-[#111827] mb-3" data-id="element-1602" data-mp="2woy5r5toz0h9">
                  {item.label}
                </div>
                <p className="text-[#6B7280] leading-relaxed text-sm" data-id="element-1603" data-mp="31ly8b6rc1l3m">
                  {item.description}
                </p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8" data-id="element-1604" data-mp="2pjx0uybm4k2p">
            {[{
            title: 'Alles onder één dak',
            description: 'Website, hosting, SEO en e-mail bij één partij. Snellere communicatie, betere afstemming, geen gedoe met verschillende leveranciers.'
          }, {
            title: 'Proactief onderhoud',
            description: 'We wachten niet tot er iets misgaat. Updates, beveiligingspatches en optimalisaties worden automatisch en regelmatig uitgevoerd.'
          }, {
            title: 'Schaalbaar wanneer je groeit',
            description: 'Van een eenvoudige website tot een uitgebreide webshop, onze hosting groeit mee zonder dat je hoeft te migreren.'
          }, {
            title: 'Persoonlijk contact',
            description: 'Geen ticketsystemen of chatbots. Je hebt direct contact met het team dat je website heeft gebouwd en beheert.'
          }].map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white rounded-xl p-6 flex items-start gap-4 shadow-sm border border-gray-100" data-id="element-1605" data-mp="13vkvxoboc5i0" data-mpi={index}>
                <div className="w-8 h-8 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-1606" data-mp="1mrkpv4o7pj48">
                  <CheckCircleIcon className="h-5 w-5 text-[#007AFF]" data-id="element-1607" data-mp="1rp44i5otnxwp" />
                </div>
                <div data-id="element-1608" data-mp="2feyhqod1zohh">
                  <h3 className="font-bold text-[#111827] text-lg mb-1" data-id="element-1609" data-mp="2k7rn9egcj0um">
                    {item.title}
                  </h3>
                  <p className="text-[#6B7280] text-sm leading-relaxed" data-id="element-1610" data-mp="k5s4tiu3tdjh">
                    {item.description}
                  </p>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="text-center mt-12" data-id="element-1611" data-mp="aggvpw77w8vl">
            <p className="text-[#6B7280] mb-4" data-id="element-1612" data-mp="13206ydrtl8ak">
              Benieuwd wat hosting bij Noord Digital voor jouw website kan betekenen?
            </p>
            <motion.a href="/contact" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-flex items-center bg-[#007AFF] text-white font-semibold py-3 px-8 rounded-lg shadow-md group" data-id="element-1613" data-mp="t5597x3dfbxc">
              Vraag een vrijblijvend gesprek aan
              <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1614" data-mp="39tiy23hagahb" />
            </motion.a>
          </motion.div>
        </div>
      </div>

      {/* Norden SSL */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1615" data-mp="1temuj0ftkysj">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1616" data-mp="1yd7wb4apzqj3">
          <div className="max-w-4xl mx-auto" data-id="element-1617" data-mp="233wpco21svkc">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-[#007AFF] to-[#005FCC] rounded-2xl p-8 md:p-12 text-white shadow-xl" data-id="element-1618" data-mp="235rb24l58rph">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-1619" data-mp="2h4h5tdkhqfao">
                <div className="text-center md:text-left" data-id="element-1620" data-mp="2m1zfj66c0yjq">
                  <div className="inline-block relative" data-id="element-1621" data-mp="mq6i58fmtr6h">
                    <motion.div initial={{
                    opacity: 0,
                    scale: 0.8
                  }} whileInView={{
                    opacity: 1,
                    scale: 1
                  }} viewport={{
                    once: true
                  }} transition={{
                    type: 'spring',
                    stiffness: 100
                  }} className="w-40 h-40 bg-white bg-opacity-20 rounded-full flex items-center justify-center p-4 relative overflow-hidden backdrop-blur-sm" data-id="element-1622" data-mp="mrrd2z5uzc4v">
                      <img src="https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png" alt="Norden regelt SSL certificaat en updates" className="w-full h-full object-cover" data-id="element-1623" data-mp="q7pae4nnytda" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, 5, 0]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} className="absolute -top-2 -right-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1624" data-mp="147hwtns5qnfg">
                      <LockIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1625" data-mp="3aziscxefza57" />
                    </motion.div>
                    <motion.div animate={{
                    y: [0, -5, 0],
                    rotate: [0, -360]
                  }} transition={{
                    y: {
                      duration: 4,
                      repeat: Infinity
                    },
                    rotate: {
                      duration: 10,
                      repeat: Infinity,
                      ease: 'linear'
                    }
                  }} className="absolute -bottom-2 -left-2 w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-lg" data-id="element-1626" data-mp="1s44rnzx205h4">
                      <RefreshCwIcon className="h-6 w-6 text-[#007AFF]" data-id="element-1627" data-mp="270vqo82tff67" />
                    </motion.div>
                  </div>
                </div>
                <div data-id="element-1628" data-mp="1x1d91yado5hb">
                  <motion.h2 initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} className="font-bold text-white text-3xl mb-4" data-id="element-1629" data-mp="1x26acjqki2s2">
                    Norden regelt je SSL en je updates
                  </motion.h2>
                  <motion.p initial={{
                  opacity: 0,
                  x: 20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.1
                }} className="text-white text-opacity-90 text-lg leading-relaxed mb-6" data-id="element-1630" data-mp="n1anz46ir81m">
                    Geen gedoe met technische zaken. Norden zorgt automatisch voor je SSL-certificaat, draait updates op een rustig moment en houdt alles veilig. Jij focust op je klanten.
                  </motion.p>
                  <div className="space-y-3" data-id="element-1631" data-mp="3rimu8qm4usx1">
                    <div className="flex items-center gap-3" data-id="element-1632" data-mp="3rfs88unh101i">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1633" data-mp="3vk02168sd66l" />
                      <span className="text-white text-opacity-90" data-id="element-1634" data-mp="3hkgrk6si5ir4">
                        Automatische SSL-installatie en verlenging
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1635" data-mp="32vx92w6jhnja">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1636" data-mp="32yjp7k7hxbd4" />
                      <span className="text-white text-opacity-90" data-id="element-1637" data-mp="2xzqdnxbrrufl">
                        Wekelijkse updates van WordPress en plugins
                      </span>
                    </div>
                    <div className="flex items-center gap-3" data-id="element-1638" data-mp="37uib915cqhad">
                      <CheckCircleIcon className="h-5 w-5 text-white flex-shrink-0" data-id="element-1639" data-mp="3lut4uby1q9z8" />
                      <span className="text-white text-opacity-90" data-id="element-1640" data-mp="3gx1cxhxeinv1">
                        Proactieve beveiligingscontroles
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Voor wie + cross-sell */}
      <div className="w-full bg-white py-20 md:py-24" data-id="element-1641" data-mp="8h7x75aw9gf1">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1642" data-mp="4fmkpl29v45d">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1643" data-mp="1xxtlwwfniut5">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-[#111827] mb-4 text-3xl md:text-4xl" data-id="element-1644" data-mp="1xxjv56ms8jme">
              Voor wie werkt deze hosting goed?
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-[#6B7280] text-lg leading-relaxed mb-8" data-id="element-1645" data-mp="2coiz24coajzn">
              Naast standaard webhosting hebben we ook ervaring met webshops, WooCommerce en maatwerk-applicaties. Ons hostingpakket groeit mee.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="flex items-center justify-center gap-3 mb-8" data-id="element-1646" data-mp="30b92na4o6mmd">
              <ShoppingCartIcon className="h-8 w-8 text-[#007AFF]" data-id="element-1647" data-mp="oq03d87tzbwj" />
              <span className="text-[#6B7280] font-medium" data-id="element-1648" data-mp="jxyvdyhp47cb">
                Geschikt voor WooCommerce en maatwerk
              </span>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1649" data-mp="ex1cfjov399r">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -5,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)'
          }} className="bg-[#F7F8FA] rounded-2xl p-6 transition-all duration-300 group" data-id="element-1650" data-mp="50y39tvleadb" data-mpi={index}>
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 5
            }} className="w-12 h-12 bg-[#007AFF] bg-opacity-10 rounded-full flex items-center justify-center text-[#007AFF] mb-4" data-id="element-1651" data-mp="1qfm1mbkzxj4t">
                  {benefit.icon}
                </motion.div>
                <h3 className="font-bold text-[#111827] text-lg mb-2" data-id="element-1652" data-mp="20jiw1e9m9tpu">
                  {benefit.title}
                </h3>
                <p className="text-[#6B7280] leading-relaxed" data-id="element-1653" data-mp="25hkhu6yfg750">
                  {benefit.description}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-[#F7F8FA] to-[#E8F0FE] rounded-2xl p-8 max-w-3xl mx-auto mt-12" data-id="element-1654" data-mp="2x76zcq50rhpc">
            <h3 className="font-bold text-[#111827] text-xl mb-4 text-center" data-id="element-1655" data-mp="17siq2xrq6fvj">
              Compleet pakket bij één partij
            </h3>
            <p className="text-[#6B7280] text-center mb-6" data-id="element-1656" data-mp="1cqk9xkwz6j82">
              Combineer je hosting met onze andere diensten voor een professionele online aanwezigheid.
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-id="element-1657" data-mp="109j5wpwfwkb4">
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1658" data-mp="1ea2fi1gjzyfe">
                Onepager vanaf €499
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1659" data-mp="hl4isdp8tqfl" />
              </motion.a>
              <motion.a href="/email" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1660" data-mp="vcsu4ero4avi">
                Zakelijke e-mail vanaf €1,99
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1661" data-mp="39fmtdx8gc3tl" />
              </motion.a>
              <motion.a href="/seo" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-6 py-3 bg-white text-[#007AFF] font-semibold rounded-lg shadow-sm group" data-id="element-1662" data-mp="3dhhv32uaoj7w">
                SEO optimalisatie
                <ArrowRightIcon className="h-4 w-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1663" data-mp="3sdqtk26d2sj9" />
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* CTA */}
      <div className="w-full bg-gradient-to-br from-[#007AFF] to-[#005FCC] py-20 md:py-24" data-id="element-1664" data-mp="52zqjb3kblt1">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px]" data-id="element-1665" data-mp="a24042uefljw">
          <div className="max-w-3xl mx-auto text-center" data-id="element-1666" data-mp="f0nqqgjxtlil">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-bold text-white text-3xl md:text-4xl mb-6" data-id="element-1667" data-mp="jxnweqcvkm96">
              Eerlijk geprijsd, alles inbegrepen
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-white text-opacity-90 text-lg leading-relaxed mb-8" data-id="element-1668" data-mp="1uj3eptemjztf">
              €34,99 per maand, geen verrassingen, geen losse posten voor SSL of backups. Wij hosten je website op onze eigen omgeving, jij hebt er geen omkijken naar.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="flex flex-wrap gap-4 justify-center" data-id="element-1669" data-mp="28il9qqiik9b8">
              <motion.a href="/contact" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-white text-[#007AFF] font-semibold rounded-lg shadow-lg group" data-id="element-1670" data-mp="6pq9mxm36mrm">
                Neem contact op
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1671" data-mp="botfgk9w4x0n" />
              </motion.a>
              <motion.a href="/websites" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-white text-white font-semibold rounded-lg group" data-id="element-1672" data-mp="pn9km6s3ufgo">
                Website laten maken
                <ArrowRightIcon className="h-5 w-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-1673" data-mp="18fbvt2lz93jj" />
              </motion.a>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer data-id="element-1674" data-mp="13eegcxscqnlq" />
    </div>;
};